const englishTranslations = {
  SELECT_CHAT: {
    topHeading: "Select Messaging",
    msgDoctor: "Message Doctor",
    msgReceptionist: "Message Receptionist",
  },
  CHAT: {
    msgDoctor: "Message Doctor",
    msgReceptionist: "Message Receptionist",
    DoctorInputText:
      "Write medical issues clearly. For appointments, contact receptionist. \nNot a live chat. Responses may be delayed.",
    ReceptionistInputText:
      "Write clearly to the receptionist. \nThis is not a live chat. Replies will take time.",
  },
};

const marathiTranslations = {
  SELECT_CHAT: {
    topHeading: "Select Messaging",
    msgDoctor: "Message Doctor",
    msgReceptionist: "Message Receptionist",
  },
  CHAT: {
    msgDoctor: "Message Doctor",
    msgReceptionist: "Message Receptionist",
    DoctorInputText:
      "Write medical issues clearly. For appointments, contact receptionist. \nNot a live chat. Responses may be delayed.",
    ReceptionistInputText:
      "Write clearly to the receptionist. \nThis is not a live chat. Replies will take time.",
  },
};

const hindiTranslations = {
  SELECT_CHAT: {
    topHeading: "Select Messaging",
    msgDoctor: "Message Doctor",
    msgReceptionist: "Message Receptionist",
  },
  CHAT: {
    msgDoctor: "Message Doctor",
    msgReceptionist: "Message Receptionist",
    DoctorInputText:
      "Write medical issues clearly. For appointments, contact receptionist. \nNot a live chat. Responses may be delayed.",
    ReceptionistInputText:
      "Write clearly to the receptionist. \nThis is not a live chat. Replies will take time.",
  },
};

export const translations = {
  EN: englishTranslations,
  MR: marathiTranslations,
  HI: hindiTranslations,
};
